<template>
  <div :id="id" class="form-group">
    <ncs-label :id="`filters.${this.id}`"/>
    <div class="slider-container">
      <vue-slider v-model="slider" :min="minSliderValue" :max="maxSliderValue" :interval="interval"
                  tooltip-placement="bottom" :lazy="true" :disabled="isDisabled"/>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'

  export default {
    name: 'SliderFilter',
    components: {VueSlider},
    props: {
      name: {type: String},
      field: {type: String, required: true},
      disabled: {type: Boolean, default: false},
      dependencies: {type: Array, default: () => []},
      requireParents: {type: Boolean, default: false},
      min: {type: Number},
      max: {type: Number},
      interval: {type: Number, default: 1}
    },
    created() {
      this.$store.commit('filters/addFilter', {
        id: this.fromId,
        field: this.field,
        dependencies: this.dependencies,
        operator: 'gteq',
        default: null
      })
      this.$store.commit('filters/addFilter', {
        id: this.toId,
        field: this.field,
        dependencies: this.dependencies,
        operator: 'lteq',
        default: null
      })
    },
    computed: {
      ...mapGetters('filters', ['minValue', 'maxValue']),
      id() {
        return this.name || this.field
      },
      fromId() {
        return `${this.field}_from`
      },
      toId() {
        return `${this.field}_to`
      },
      isDisabled() {
        return this.disabled || (this.requireParents && this.$store.getters['filters/parentsEmpty'](this.id))
      },
      minSliderValue() {
        return this.min || this.minValue(this.fromId)
      },
      maxSliderValue() {
        return this.max || this.maxValue(this.toId)
      },
      from: {
        get() {
          const value = this.$store.getters['filters/selectedValue'](this.fromId)
          return value === null ? this.minSliderValue : value
        },
        set(v) {
          this.$store.commit('filters/setFilter', {[this.fromId]: v === this.minSliderValue ? null : v})
        }
      },
      to: {
        get() {
          const value = this.$store.getters['filters/selectedValue'](this.toId)
          return value === null ? this.maxSliderValue : value
        },
        set(v) {
          this.$store.commit('filters/setFilter', {[this.toId]: v === this.maxSliderValue ? null : v})
        }
      },
      slider: {
        get() {
          return [this.from, this.to]
        },
        set(v) {
          this.from = v[0]
          this.to = v[1]
        }
      }
    },
    watch: {
      isDisabled: {
        immediate: true,
        handler(value) {
          if (value) {
            // Value should be null for disabled filters
            this.$store.commit('filters/setFilter', {[this.fromId]: null, [this.toId]: null})
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .slider-container {
    padding-top: 8px;
  }
</style>